import React from 'react';

const Background = () => {
    return (<div className="background">
        <div className="line line-left line-from-back line-alternate"></div>
        <div className="line line-left line-from-back"></div>
        <div className="line line-left line-from-front line-alternate"></div>
        <div className="line line-right line-from-back line-alternate"></div>
        <div className="line line-right line-from-front"></div>
        <div className="line line-right line-from-front line-alternate"></div>
    </div>);
}

export default Background;
